import React from 'react';
import { X } from 'lucide-react';

interface VideoPopupProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl?: string;
}

const VideoPopup: React.FC<VideoPopupProps> = ({ 
  isOpen, 
  onClose, 
  videoUrl = "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/demo-video.mp4" 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="relative bg-white rounded-lg shadow-2xl max-w-4xl w-full mx-4 animate-scale-in">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-4 -right-4 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-colors z-10"
        >
          <X className="w-6 h-6 text-gray-600" />
        </button>
        
        {/* Video Container */}
        <div className="relative aspect-video rounded-lg overflow-hidden">
          <video
            className="w-full h-full object-cover"
            controls
            autoPlay
            muted
            playsInline
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        
        {/* Video Info */}
        <div className="p-6 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-2">Platform Demo</h3>
          <p className="text-gray-600">See how our all-in-one marketing platform works</p>
        </div>
      </div>
    </div>
  );
};

export default VideoPopup;